import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import BookAppointment from "./pages/BookAppointment";
import AdminAppointments from "./pages/AdminAppointments";
import Login from "./pages/Login";
import AdminLayout from "./components/AdminLayout";
import AdminUsers from "./pages/AdminUsers";
import AdminSettings from "./pages/AdminSettings";
import FloatingSocials from "./components/FloatingSocials";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/book-appointment" element={<BookAppointment />} />
          
          {/* Admin Authentication Route */}
          <Route path="/admin/login" element={<Login />} />
          
          {/* Protected Admin Routes */}
          <Route element={<AdminLayout />}>
            <Route path="/admin-appointments" element={<AdminAppointments />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
          </Route>
        </Routes>
        <FloatingSocials />
      </BrowserRouter>
    </AuthProvider>
  );
}